import { cx } from "class-variance-authority"
import { type ComponentPropsWithoutRef, forwardRef } from "react"

export type TopBarContainerProps = ComponentPropsWithoutRef<"div">

export const TopBarContainer = forwardRef<HTMLDivElement, TopBarContainerProps>((props, ref) => {
	const { className, children, ...rest } = props

	return (
		<div
			ref={ref}
			className={cx(
				"border-(--base-6) bg-(--color-background) dark:bg-(--base-2) relative flex h-full w-full border-b p-4",
				className,
			)}
			{...rest}
		>
			{children}
		</div>
	)
})
TopBarContainer.displayName = "TopBarContainer"
